// extracted by css-extract-rspack-plugin
export default {"header":"_44ea90dc"};